import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Col, Flex, Modal, Row, Spin } from 'antd';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { userHasPermission } from "../../../../../swzutils/UserPermissionsUtil";
import { axiosErrorHandler } from "../../../../../swzutils";
import ImageGalleryLightbox from "../../../components/ImageGalleryLightbox";
import API from "../../../../../API";
import { loggedInUserSelector } from "../../../../../store/slice/auth";
import { useAppSelector } from "../../../../../store";
import { ImageLoader } from "../../../components/ImageLoader";
const VehicleHireDocketList = ({ editable = false, vehicleHireId }) => {
    const [lightBoxOpen, setLightBoxOpen] = useState(false);
    const [lightBoxIndex, setLightBoxIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    const [dockets, setDockets] = useState([]);
    const navigate = useNavigate();
    const [modal, contextHolder] = Modal.useModal();
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useEffect(() => {
        loadDockets();
    }, [vehicleHireId]);
    const loadDockets = () => {
        if (!vehicleHireId) {
            return;
        }
        setLoading(true);
        axios.get(`/admin/v1/vehicle-hires/${vehicleHireId}/dockets`)
            .then(response => setDockets(response.data))
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    const openLightBox = (docketId) => {
        setLightBoxOpen(true);
        setLightBoxIndex(dockets.findIndex(item => item.id === docketId));
    };
    const onEditClicked = (docket) => {
        navigate(`/app/vehicle-hires/${vehicleHireId}/dockets/${docket.id}`);
    };
    const onDeleteClicked = (docket) => {
        modal.confirm({
            title: 'Are you sure?',
            content: 'This will completely remove the docket.  This action cannot be undone.',
            okText: 'Yes',
            cancelText: 'No',
            onOk: () => deleteDocket(docket)
        });
    };
    const deleteDocket = (docket) => {
        setLoading(true);
        axios.delete(`/admin/v1/vehicle-hires/${vehicleHireId}/dockets/${docket.id}`)
            .then(( /*response*/) => setDockets(dockets.filter(item => item.id !== docket.id)))
            .catch(axiosErrorHandler)
            .finally(() => setLoading(false));
    };
    return (_jsxs(Spin, { spinning: loading, style: {
            maxHeight: 400,
            overflow: 'auto',
            padding: '0 16px 0 0', // Cater for the vert scrollbar, without this a horizontal scrollbar will appear
        }, children: [contextHolder, _jsx(Flex, { vertical: true, gap: 8, children: dockets.map((docket) => (_jsxs(Flex, { gap: 16, children: [_jsx("a", { onClick: () => openLightBox(docket.id), children: _jsx(ImageLoader, { src: `${API.origin()}/admin/v1/vehicle-hires/${vehicleHireId}/dockets/${docket.id}/thumbnail`, alt: "Docket Photo" }) }), _jsxs("div", { children: ["Net: ", _jsx("strong", { children: docket.net }), _jsx("br", {}), docket.comments, editable && userHasPermission(loggedInUser, ['admin:vehicleHireDocket:update', 'admin:vehicleHireDocket:delete']) &&
                                    _jsxs(Row, { gutter: 10, children: [userHasPermission(loggedInUser, ['admin:vehicleHireDocket:update']) &&
                                                _jsx(Col, { xs: 12, children: _jsx(Button, { block: true, type: "default", htmlType: "button", onClick: () => onEditClicked(docket), children: "Edit" }) }), userHasPermission(loggedInUser, ['admin:vehicleHireDocket:delete']) &&
                                                _jsx(Col, { xs: 12, children: _jsx(Button, { block: true, type: "default", htmlType: "button", onClick: () => onDeleteClicked(docket), children: "Delete" }) })] })] })] }))) }), lightBoxOpen &&
                _jsx(ImageGalleryLightbox, { open: lightBoxOpen, initialIndex: lightBoxIndex, images: dockets.map(docket => {
                        return {
                            url: `${API.origin()}/admin/v1/vehicle-hires/${vehicleHireId}/dockets/${docket.id}/image`,
                            title: (_jsxs(_Fragment, { children: ["Net: ", _jsx("strong", { children: docket.net })] })),
                            caption: docket.comments
                        };
                    }), onClose: () => setLightBoxOpen(false) })] }));
};
export default VehicleHireDocketList;
